import SaleSummary from "./../Flight/SaleSummary";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { flight_dateTimeFormat, set_flight_fare } from "../../pages/Home";
import moment from "moment";
import parse, { domToReact } from 'html-react-parser';
import { Link } from "react-router-dom";
import { PassengerData } from "../../pages/AddPassenger";

const ReturnReviewBooking = () => {
  const search_data = useSelector(state => state.global.search_data)
  const flight_data = useSelector(state=>state.global.flights_list)
  const user_id = useSelector(state => state.global.user_id)
  const fare_rule = useSelector(state => state.global.fare_rule)
  const fare_quote = useSelector(state => state.global.fare_quote)
  const passenger_ids = useSelector(state => state.global.passenger_ids)
  
  const request_passenger = JSON.parse(localStorage.getItem('request_passenger'))
  // console.log('fare_quote',fare_quote);
  var airline=[];
  const Segments = fare_quote.status ? fare_quote.Results.Segments : []
  const Results = fare_quote.status ? fare_quote.Results : []
  var duration = 0;
  const airlines = useSelector((state) => state.global.airlines);
  const flight_token = useSelector((state) => state.global.flight_token);
  var airline_check = "";
  var departure_date = "";
  var arrival_date = "";
  var origin_check = "";
  var dest_check = "";

  const get_payment_gateway = () => {
    
    const params = {
        TXN_AMOUNT:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? set_flight_fare(fare_quote.Results.Fare,
          fare_quote.Results.AirlineCode, airlines) : 0,
        CUST_ID:user_id,
        user_id:user_id,
        IsLCC:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('IsLCC') ? fare_quote.Results.IsLCC : false,
        ResultIndex:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('ResultIndex') ? fare_quote.Results.ResultIndex : '',
        TraceId:fare_quote.status && fare_quote.hasOwnProperty('TraceId') ? fare_quote.TraceId : '',
        TokenId:flight_token.TokenId,
    }
    // console.log((params))
    // alert()
    // return;
    // The rest of this code assumes you are not using a library.
    // It can be made less verbose if you use one.
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://apnaatravel.com/apnaatravelIAMadmin/Payment/paytm_redirect';
  
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
  
        form.appendChild(hiddenField);
      }
    }
  
    document.body.appendChild(form);
    form.submit();
}

  return fare_quote.status ? (
    <>
      <div className="container mt-4">
        <div class="row">
          <div class="col-lg-9">
            <div className="row">
              <div class="card" style={{ width: "57rem" }}>
                <div class="card-header">Booking Details</div>

                <div className="card-body">
                  <div className="row">
                    <div class="col-lg-6">
                      {" "}
                      <div class="card-header" style={{ color: "blue" }}>
                        Journey Detail
                      </div>
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        {Segments.length
                          ? Segments.map((datas, seg_ind) => {
                            const have_next_asset = Segments.length > 1 ? true : false
                            const total_assets = datas.length
                            return datas.map((airport, index) => {
                              duration += airport.Duration;
                              airline.push(airport.Airline.AirlineCode)
                              if(seg_ind == 0 && index == 0){
                                origin_check=airport.Origin.Airport.AirportCode;
                              }
                              if(seg_ind == 1 && index == datas.length - 1){
                                dest_check = airport.Destination.Airport.AirportCode;
                                departure_date = flight_dateTimeFormat(airport.Origin.DepTime);
                                arrival_date = flight_dateTimeFormat(airport.Destination.ArrTime)
                              }
                  
                              return (
                                <>

                                    {seg_ind == 0 && index == 0 ? airport.Origin.Airport.AirportCode : ''}
                                    {seg_ind == 0 && index == 0 ?
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-arrow-right-short"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                                        />
                                      </svg>
                                      : <></>
                                    }
                                    {have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ? airport.Destination.Airport.AirportCode : "") : (seg_ind == 0 && index == datas.length - 1 ? airport.Destination.Airport.AirportCode : "")}
                                  {/* <p style={{ fontSize: "10px" }}>
                                    <strong>{have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "") : (seg_ind == 0 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "")}</strong>
                                  </p> */}
                                  {index==0? ", "+airport.Airline.AirlineName+" - "+airport.Airline.AirlineCode : ""} <br />
                                  {have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "") : (seg_ind == 0 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "")}
                                </>
                              )

                            })
                          })
                          : ""
                        }, 
                        </li>
                      </ul>
                    </div>
                    <div class="card" style={{ width: "57rem" }}>
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item" style={{ color: "blue" }}>
                          Total Publish: Rs. {set_flight_fare(fare_quote.Results.Fare, fare_quote.Results.AirlineCode, airlines)}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="card-header">Flight Information</div>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">OutBound</li>
                </ul>

                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <div class="row">
                      <div class="row row-cols-auto">
                        <div class="col">
                          <div
                            class="card"
                            style={{
                              width: "7rem",
                            }}
                          >
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Flight No</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card" style={{ width: "6rem" }}>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Origin</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card" style={{ width: "8rem" }}>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Destination</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card" style={{ width: "10rem" }}>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Dep Date Time</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card" style={{ width: "9rem" }}>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Arr Date Time</li>
                            </ul>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card" style={{ width: "6rem" }}>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">Class</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                    {Segments.length
                          ? Segments.map((datas, seg_ind) => {
                            const have_next_asset = Segments.length > 1 ? true : false
                            const total_assets = datas.length
                            return datas.map((airport, index) => {
                          
                              return (
                                <>
                                  <div class="row row-cols-auto">
                                    <div class="col">
                                      <div style={{ width: "7rem" }}>
                                        <li class="list-group-item">{airport.Airline.AirlineCode}-{airport.Airline.FlightNumber}</li>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div style={{ width: "6rem" }}>
                                        <li class="list-group-item">{airport.Origin.Airport.AirportCode}</li>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div style={{ width: "8rem" }}>
                                        <li class="list-group-item">{airport.Destination.Airport.AirportCode}</li>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div style={{ width: "10rem" }}>
                                        <li class="list-group-item">
                                          {moment(airport.Origin.DepTime).format('DD-MM-YYYY HH:mm')} hrs
                                        </li>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div style={{ width: "9rem" }}>
                                        <li class="list-group-item">
                                        {moment(airport.Destination.ArrTime).format('DD-MM-YYYY HH:mm')} hrs
                                        </li>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div style={{ width: "6rem" }}>
                                        <li class="list-group-item">{airport.Airline.FareClass}</li>
                                      </div>
                                    </div>
                                  </div>

                                    
                                </>
                              )
                              // }

                            })
                          })
                          : ""
                        }
                      
                    </div>
                  </li>
                  <div class="card-header">Passenger Details
                  {/* <Link 
                  to={{
                    pathname:
                    "/add-passenger/" +
                    flight_token.TokenId +
                    "/" +
                    flight_data.TraceId +
                    "/" +
                    fare_quote.Results.ResultIndex
                  }}
                  >+add passenger</Link> */}
                  </div>

                  {/* outside passsanger */}
                  <div className="row">
                    <div className="card">

                      <div className="card-body">
                        <div>
                          <h4>Enter Passenger Details</h4>
                        </div>
                        {
                          fare_quote.Results.FareBreakdown.map((dt, index) => {
                            var psgrdata = []
                            for (var i = 0; i < dt.PassengerCount; i++) {
                              psgrdata.push(<PassengerData  {...dt} count_no={i} />)
                            }
                            return <>{psgrdata}</>

                          })
                        }
                      </div>

                    </div>
                  </div>
                  {/* outside passsanger */}

                  {/* <div class="card-header">Passenger 1- (Adult)</div>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-lg-3">Name :</div>
                      <div class="col-lg-9">Mr. KK</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">Gender :</div>
                      <div class="col-lg-9">Male</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">Address :</div>
                      <div class="col-lg-9">272/A, A block Mahipalpur Ext</div>
                    </div>
                  </li> */}
                  <div class="card-header">Fare Rule</div>

                  <li class="list-group-item">
                    {
                      fare_rule.status &&
                      fare_rule.FareRules.map(dt=>{
                        return <>
                        {parse(dt.FareRuleDetail)}
                      </>
                      })
                    }
                    
                  </li>
                  <div class="card-header">Terms and Conditions</div>
                  <li class="list-group-item">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        <p>
                          I have reviewed and agreed on the fares and commission
                          offered for this booking
                        </p>
                        <p style={{ color: "red" }}>
                          Note: You can earn more commission if you checked the
                          travel Insurance
                        </p>
                      </label>
                    </div>
                  </li>
                  <div class="card-header">Payment Option(s)</div>

                  <p style={{ color: "red" }}>
                    Important Note: for Online payment it is advised to use
                    Mozilla Firefox or Internet Explorer browser for making
                    bookings on portal and avoid Chrome browser. We are working
                    on chrome browser issue with our payment gateway merchants
                  </p>
                  <div class="form-check">
                      <div class="btn-box">
                          <button class="theme-btn m-4" type="button" onClick={get_payment_gateway}>Confirm Booking</button>
                      </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <SaleSummary {...fare_quote}  />
          </div>
        </div>
      </div>
    </>
  ) : <></>;
};
export default ReturnReviewBooking;
